

import React, { useState, useContext, useEffect, useRef } from "react";
import { Card, CardBody, CardHeader, CardTitle, CardFooter, Col, Row, Container, Button, InputGroup } from "reactstrap";
import { Link, useNavigate, useParams } from 'react-router-dom';
import Select from "react-select";
import Form from 'react-bootstrap/Form';
import AddFileInput from './addFileInput';

import Flatpickr from "react-flatpickr";
import Loading from "../../lib/components/Loading.js";
import UseMoondanceApi from "../../lib/api";
import { MoondanceContext } from '../../../App';
import MoondanceLayout from "../../lib/layout";
import { testurl, formatGroupLabel, groupAndSortPositions, buildAccountParameter, buildTransactionTypeList, formatOptionLabel, formatDate, } from "../../lib/formatData.js";

import ReactQuill from 'react-quill';

const AddFile = (props) => {

    // Initialize Moondance API and context
    const moondanceApi = UseMoondanceApi();
    const { selectedAccountList } = useContext(MoondanceContext);
    const { selectedStatus } = useContext(MoondanceContext);
    const { userCurrency, setUserCurrency } = useContext(MoondanceContext);
    const { addAlert } = useContext(MoondanceContext);
    let navigate = useNavigate();
    const flatpickrRef = useRef(null);

    const params = useParams();
    const id = (params.id ? params.id : false);

    // State variables for managing file upload and position selection
    const [positionList, setPositionList] = useState(null);
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [description, setDescription] = useState('');
    const [summary, setSummary] = useState('');
    const [file, setFile] = useState(null);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(() => {
        return props.data && props.data.date_int
            ? props.data.date_int
            : new Date().toISOString().split('T')[0]; // format: YYYY-MM-DD
    });
    let modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image', 'video'],
            ['clean']
        ],
    };

    let formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image', 'video'
    ];
    useEffect(() => {
        console.log('file changed', file);
        if (file && file.name) {
            setDescription(file.name);
        }
    }, [file]);

    useEffect(() => {
        if (selectedPosition && selectedPosition !== 'null') {
            setSelectedPosition(selectedPosition);
        } else {
            setSelectedPosition(id);
        }
    }, [id]);

    function handleSelectDate(selectedDates, dateStr, instance) {
        console.log('Selected date:', selectedDate, dateStr);
        setSelectedDate(dateStr);
    }

    // Function to fetch the list of positions based on selected accounts and status
    async function fetch_position_list(selectedAccountOnly = true) {
        var api_parameters = {
            account: buildAccountParameter(selectedAccountList),
            status: 'All',
            userCurrency: userCurrency,
        }
        try {
            const response = await moondanceApi.fetchPositionsList(api_parameters)
            if (response && response.data.length > 0) {
                let positionList = groupAndSortPositions(response.data)  ///SECURITY
                setPositionList(positionList)

            } else {
                return []
            }
        } catch (error) {
            console.log('error', error);
            return []
        }
        return []
    }
    // Effect to fetch the position list when the component mounts or when selected accounts or status changes
    useEffect(() => {
        fetch_position_list(true);

    }, [selectedAccountList, selectedStatus]);

    useEffect(() => {
        if (positionList && positionList.length > 0) {
            setLoading(false);
        }
    }, [positionList]);
    async function uploadFile(fileContent, fileName, positionId, description = "") {
        if (!(fileContent instanceof File)) {
            console.error("fileContent is not a File object");
            return Promise.reject("Invalid file object");
        }
        let newDate = selectedDate;
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(selectedDate)) {
            const parts = selectedDate.split('/');
            const newDateStr = `${parts[2]}-${parts[1]}-${parts[0]}`;
            let newDate  = newDateStr;
        } 
        const formData = new FormData();
        formData.append("file", fileContent, fileName || fileContent.name);
        formData.append("position_id", String(positionId || 0));
        formData.append("description", description);
        formData.append("date", newDate);
        formData.append("summary", summary);    
        console.log("📤 Uploading file:", fileName, "to position:", positionId);

        try {
            const response = await moondanceApi.uploadFile(formData);
            if (response?.success) {
                console.log("✅ Upload success:", response);
                return response;
            } else {
                throw new Error(response?.message || "Upload failed");
            }
        } catch (error) {
            console.error("❌ Upload error:", error);
            addAlert({
                status: "danger",
                title: "File upload failed",
                message: error?.message || error,
            });
            throw error;
        }
    }
    async function linkFileToPosition(file, positionId) {

        let requestData = {
            file_id: file,
            position_id: positionId,
        }
        console.log("🔗 Linking file:", file, "to position:", positionId);
        try {
            const response = await moondanceApi.linkFileToPosition(requestData);
            if (response?.success) {
                console.log("✅ File linked to position:", response);
                return response;
            } else {
                throw new Error(response?.message || "Link to position failed");
            }
        } catch (error) {
            console.error("❌ Link error:", error);
            addAlert({
                status: "danger",
                title: "Failed to link file to position",
                message: error?.message || error,
            });
            throw error;
        }

    }

    async function handleUploadFile() {
        let positionId = parseInt(selectedPosition);
        if (!selectedPosition || isNaN(positionId) || positionId <= 0) {
            addAlert({
                status: "danger",
                title: "Please select a position",
                message: "The file must be linked to a valid position.",
            });
            return;
        }

        if (!file) {
            addAlert({
                status: "danger",
                title: "Please select a file",
                message: "No file selected for upload.",
            });
            return;
        }

        try {
            let result = await uploadFile(file, file.name, positionId, description);
            console.log("File upload result:", result);
            if (result && result.data && result.data.success && result.data.file_id) {
                addAlert({
                    status: "success",
                    title: "File upload Successful",
                    message: "File uploaded successfully to position: " + positionId,
                });
                // Reset form state
                let link = await linkFileToPosition(result.data.file_id, selectedPosition);

                setFile(null);
                setDescription("");
                //setSelectedPosition(null);
                setSuccess(true);
            } else {
                addAlert({
                    status: "danger",
                    title: "File upload failed",
                    message: result?.message || "An error occurred during file upload.",
                });
                setSuccess(false);
                return;
            }
        } catch (error) {
            addAlert({
                status: "danger",
                title: "File upload failed",
                message: error?.message || error,
            });
        }
    }



    return (
        <React.Fragment >
            {(loading ?
                <Loading />
                :
                <div className='page-content' style={{ minHeight: '800px' }}>
                    {(success ?
                        <Container fluid={true}>
                            <Row>
                                <h2>Add File</h2>
                                <hr />
                                <div className="d-flex align-items-center   p-2">
                                    <span className="me-3">File has been uploaded successfully</span>
                                    <Button size="btn btn-sm btn-info" onClick={() => setSuccess(false)}>Upload another file</Button>

                                    <Button size="btn btn-sm btn-outline-info" style={{ marginLeft: '1em' }} onClick={() => navigate('/position/' + selectedPosition)}>Go to position</Button>
                                </div>
                            </Row>

                        </Container>

                        :
                        <Container fluid={true}>
                            <Row>
                                <h2>Add File</h2>
                                <hr />
                                <div className="text-sm text-gray-700 p-4 bg-gray-50 rounded-md border border-gray-200">
                                    <h3 className="text-base font-semibold mb-2">🔒 File Upload Security Notice</h3>
                                    <ul className="list-disc list-inside mb-3">
                                        <li>
                                            <strong>Access Control:</strong> Files are only accessible through the Moondance platform by users who have permission to view the specific position the file is associated with.
                                        </li>
                                        <li>
                                            <strong>Temporary Access Links:</strong> All file URLs are valid for <strong>1 minute</strong> only. They are generated dynamically and cannot be reused or shared externally.
                                        </li>
                                        <li>
                                            <strong>Security Logging:</strong> Every access to a file is securely logged for audit and traceability purposes.
                                        </li>
                                    </ul>
                                    <p className="mb-2">
                                        As a <strong>best practice</strong>, we advise against using filenames that contain personal or identifiable information.
                                    </p>
                                    <p>
                                        While we apply strong security standards, <em>no system can provide absolute protection</em>. By using this feature, you acknowledge the measures we have put in place and accept that Moondance cannot guarantee 100% security.
                                    </p>
                                </div>


                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label >Select File</Form.Label>
                                    <div className="form-control" style={{ marginLeft: '12px', maxWidth: '98%' }}>

                                        {(file ?
                                            <div className="d-flex align-items-center justify-content-between bg-light p-2 rounded border">
                                                <span className="me-3">{file.name}</span>
                                                <Button color="danger" size="sm" onClick={() => setFile(null)}>Remove</Button>
                                            </div>
                                            :

                                            <AddFileInput onFileAccepted={(file) => {
                                                setFile(file);
                                            }} />

                                        )}
                                    </div>
                                    <p className="text-muted">Select a file to upload. Supported formats: PDF, DOCX, XLSX, etc.</p>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label>Title (optional)</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            placeholder="Description"
                                            onChange={(e) => { setDescription(e.target.value); }}
                                            value={description}
                                        />
                                    </InputGroup>
                                    <p className="text-muted">Optional description for the file. Default is name of the file</p>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label column sm="4">Date</Form.Label>

                                    <InputGroup>
                                    <div className="input-group-append" onClick={() => flatpickrRef.current.flatpickr.open()}>
                                            <span className="input-group-text">
                                                <i className="mdi mdi-calendar"></i>
                                            </span>
                                        </div>
                                        <Flatpickr
                                            className="form-control "
                                            onChange={handleSelectDate}
                                            value={selectedDate}
                                            options={{
                                                clickOpens: false,  // ensure this is true
                                                allowInput: true,   // ensure direct input is allowed
                                                dateFormat: "d/m/Y",
                                            }}
                                            ref={flatpickrRef}

                                        />
                                        
                                    </InputGroup>
                                    <p className="text-muted">Select the date for the file. Default is today.</p>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label>Summary (optional)</Form.Label>
                                    <ReactQuill

                                        style={{ minHeight: '25em', marginBottom: '3em' }}
                                        value={summary}
                                        onChange={(e) => { setSummary(e) }}
                                        modules={modules}
                                        formats={formats}
                                        rows={15}
                                    />
                                    <p className="text-muted">Optional description for the file.</p>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label >Select Position</Form.Label>
                                    <Select

                                        id="selectPosition"
                                        value={positionList ?
                                            positionList.flatMap(group => group.options).find(option => option.value === parseInt(selectedPosition))
                                            : null}
                                        onChange={(f) => { console.log(f.value); setSelectedPosition(f.value); }}
                                        placeholder="Select Position"
                                        options={positionList}
                                        formatOptionLabel={formatOptionLabel}
                                        formatGroupLabel={formatGroupLabel}
                                        styles={MoondanceLayout.select2customStyles}
                                    />
                                    <p className="text-muted">Every user with access to this position will be able to see this file.</p>

                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" >
                                    <Col sm={12}>
                                        <Button
                                            className="btn btn-success"
                                            onClick={() => {
                                                handleUploadFile();
                                            }}
                                        >
                                            Upload File
                                        </Button>
                                    </Col>
                                </Form.Group>


                            </Row>

                        </Container>
                    )}

                </div>
            )}
        </React.Fragment >
    );
}

export default AddFile;